 const FASTWEB_CONFIG = [{
 		tipologia: "Attivazione SIM",
 		pagamento: "Credito Residuo",
 		prezzo: 25,
 		commissione: 10
 	},
 	{
 		tipologia: "Attivazione SIM",
 		pagamento: "Domiciliazione",
 		prezzo: 25,
 		commissione: 10
 	},
 	{
 		tipologia: "Portabilità SIM",
 		pagamento: "Credito Residuo",
 		prezzo: 25,
 		commissione: 10
 	},
 	{
 		tipologia: "Portabilità SIM",
 		pagamento: "Domiciliazione",
 		prezzo: 25,
 		commissione: 2
 	}
 ]

 export default FASTWEB_CONFIG